import { route } from 'preact-router';
import { clients, searchQuery, isDesktopAdmin, isAdmin, dataLoading } from '../store/state';
import { Shell } from '../layout/Shell';
import { ClientCard } from '../components/ClientCard';
import { ClientsTable } from '../components/ClientsTable';
import { ListSkeleton } from '../components/Skeleton';
import { Icon } from '../components/Icon';

export function ClientesView() {
  const dt = isDesktopAdmin.value;
  let l = clients.value;
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    l = l.filter((c) => c.nombre.toLowerCase().includes(q) || (c.zona || '').toLowerCase().includes(q));
  }

  if (dataLoading.value) {
    return (
      <Shell tab="clientes">
        <ListSkeleton count={4} />
      </Shell>
    );
  }

  return (
    <Shell tab="clientes">
      <div class={dt ? 'toolbar' : ''}>
        <input
          type="text"
          placeholder="Buscar cliente o zona…"
          value={searchQuery.value}
          style={dt ? {} : { marginBottom: 8 }}
          onInput={(e) => (searchQuery.value = (e.target as HTMLInputElement).value)}
        />
        {isAdmin.value && (
          <button
            class="primary"
            style={dt ? { width: 'auto', marginTop: 0, padding: '10px 20px' } : { marginBottom: 12 }}
            onClick={() => route('/clientes/nuevo')}
          >
            <Icon name="user-plus" size={16} />
            Nuevo cliente
          </button>
        )}
      </div>
      {l.length ? (
        dt ? (
          <ClientsTable list={l} />
        ) : (
          l.map((c) => <ClientCard key={c.id} c={c} showState={false} />)
        )
      ) : (
        <div class="empty">
          <Icon name="users" />
          <p>{searchQuery.value ? 'Sin resultados para esa búsqueda.' : 'Todavía no hay clientes cargados.'}</p>
        </div>
      )}
    </Shell>
  );
}
